import { db, auth } from '../firebase';
import { doc, setDoc, serverTimestamp, getDoc } from 'firebase/firestore';

export type PlanId = 'base' | 'enhanced' | 'enterprise';

export interface Tenant {
  tenantId: string;
  ownerId: string;
  name: string;
  ein: string;
  merchantId: string;
  contactEmail: string;
  contactPhone: string;
  contactName: string;
  businessType: string;
  locationName: string;
  dbaName: string;
  addressLine1?: string;
  addressLine2?: string;
  city?: string;
  state?: string;
  zipCode?: string;
  status: 'Active' | 'Trial' | 'Inactive';
  subscriptionStatus: 'trialing' | 'active' | 'past_due' | 'canceled' | 'none';
  planId: PlanId;
  trialEndsAt: any;
  stripeCustomerId?: string;
  createdAt: any;
  totalTips?: number;
  referredBy?: string;
}

export const createTenant = async (tenantData: Omit<Tenant, 'tenantId' | 'ownerId' | 'status' | 'createdAt' | 'subscriptionStatus' | 'trialEndsAt' | 'planId'>): Promise<string> => {
  const userId = auth.currentUser?.uid;
  if (!userId) throw new Error("User not authenticated");

  const businessId = "BIZ-" + Math.random().toString(36).substring(2, 10).toUpperCase();
  const tenantRef = doc(db, 'tenants', businessId);
  
  const trialDays = 30;
  const trialEndDate = new Date();
  trialEndDate.setDate(trialEndDate.getDate() + trialDays);
  
  await setDoc(tenantRef, {
    ...tenantData,
    ownerId: userId,
    status: 'Trial',
    subscriptionStatus: 'trialing',
    planId: 'enhanced',
    trialEndsAt: trialEndDate,
    createdAt: serverTimestamp()
  });
  
  return businessId;
};

export const getTenant = async (tenantId: string): Promise<Tenant | null> => {
  const tenantRef = doc(db, 'tenants', tenantId);
  const tenantSnap = await getDoc(tenantRef);
  if (tenantSnap.exists()) {
    return { tenantId: tenantSnap.id, ...tenantSnap.data() } as Tenant;
  }
  return null;
};

export const updateTenant = async (tenantId: string, tenantData: Partial<Tenant>) => {
  const tenantRef = doc(db, 'tenants', tenantId);
  await setDoc(tenantRef, tenantData, { merge: true });
};
